import { en, type MessageKey } from './en'

/*
 * Arabic resource — SCAFFOLD. Same key set as en.ts (compiler-enforced).
 *
 * PER PRODUCT-RULES.md §Localisation: do NOT machine-translate the UI; every
 * value needs a translator plus a native reviewer before launch. The nav
 * values below are taken from the V1.9.1 design prototype's RTL demonstration
 * (App Shell.dc.html) — the handoff states they are a layout demonstration,
 * NOT delivered copy. Values still in English are untranslated placeholders.
 * EVERY value in this file is pending native review.
 */
export const ar: Record<MessageKey, string> = {
  // V1.9.1 Phase 2 (Orders + assign flow) — SCAFFOLD ONLY: every key from the
  // English resource is carried through UNTRANSLATED via the spread below.
  // NEEDS-NATIVE-REVIEW: all `orders.*`, `flow.*` and `assign.*` values are
  // English placeholders awaiting a translator + native reviewer (PRODUCT-
  // RULES.md §Localisation — no machine translation). Explicit overrides
  // beneath the spread are the only reviewed-for-layout demo values.
  // NEEDS-NATIVE-REVIEW: the questionnaire type-ahead keys (`quest.search.*`,
  // `quest.multi.hint`, `quest.chip.remove` — settings PR#310) ride the spread
  // below as ENGLISH placeholders awaiting a translator + native reviewer (no
  // machine translation).
  ...en,
  // NEEDS-NATIVE-REVIEW: the de-jargoned allocation copy (BOARDROOM-2026-09-
  // 01-193406) — `orders.signin.prompt`, `orders.alloc.loading`,
  // `orders.alloc.unavailable`, `orders.alloc.unconfigured`,
  // `assign.error.service`, `assign.entry.noSeat`, `assign.entry.cantOpen` —
  // rides the spread above as ENGLISH placeholders awaiting a translator +
  // native reviewer (PRODUCT-RULES.md §Localisation — no machine translation).
  // NEEDS-NATIVE-REVIEW: the Orders past-partition keys (`orders.past.title`,
  // `orders.empty.current`, `orders.empty.browse`) and the updated
  // `orders.card.invoice` label ("View invoice") — BOARDROOM-2026-09-01-175306
  // items 2–4 — ride the spread above as ENGLISH placeholders awaiting a
  // translator + native reviewer (no machine translation).
  // NEEDS-NATIVE-REVIEW: the eligibility-mismatch experience keys
  // (`eligibility.mismatch.*`, `eligibility.support.*`,
  // `getReady.step.profile.mismatch`, `getReady.pill.mismatch` — Duncan
  // rulings BOARDROOM-2026-08-29-120259 + addenda) ride the spread above as
  // ENGLISH placeholders awaiting a translator + native reviewer
  // (PRODUCT-RULES.md §Localisation — no machine translation).
  // Bottom tab bar / sidebar nav labels (from the prototype RTL demo)
  'nav.getReady': 'استعد', // NEEDS-NATIVE-REVIEW
  'nav.orders': 'الطلبات', // NEEDS-NATIVE-REVIEW
  'nav.tickets': 'التذاكر', // NEEDS-NATIVE-REVIEW
  'nav.profile': 'حسابي', // NEEDS-NATIVE-REVIEW
  'nav.help': 'المساعدة', // NEEDS-NATIVE-REVIEW

  // Top bar controls — English placeholders, awaiting translation
  'topbar.help.tip': 'Help and contact support', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'topbar.lang.tip': 'Language — العربية', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  // Label on the language toggle = the language it switches TO.
  'topbar.lang.toggleLabel': 'EN', // NEEDS-NATIVE-REVIEW
  'topbar.account.tip': 'Your account', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'topbar.account.tipNamed': '{name} — your account', // NEEDS-NATIVE-REVIEW (untranslated placeholder)

  // Get ready (V1.9.1 Phase 1) — English placeholders, awaiting translation
  'getReady.upToDate.title': "You're up to date", // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'getReady.upToDate.body': 'Nothing for you to do right now.', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
  'getReady.issued.action': 'Issued', // NEEDS-NATIVE-REVIEW (untranslated placeholder)
}
